// Sample data converted to an array of objects
const validStatuses = [
  { number: 0, value: "Inactive" },
  { number: 2, value: "Pending" },
  { number: 3, value: "Approved" },
  { number: 4, value: "Reject" },
  { number: 15, value: "BookingClosed" },
  { number: 6, value: "Cancelled" },
];

// Function to get the value for a given number
export const getStatusValue = (numberToCheck) => {
  try {
    const foundStatus = validStatuses.find(
      (status) => status.number === numberToCheck
    );
    return foundStatus ? foundStatus.value : "other"; // Return "other" if no match is found
  } catch (error) {
    console.error("Error finding status value:", error.message);
    return "other"; // Return "other" in case of an error
  }
};
